import { Agent } from '@nemuru-eng/js-api-client';

import { FlexRow } from '@/components/shared/components/FlexRow';
import { Icon } from '@/components/shared/components/Icon';
import { StatusTag } from '@/components/shared/components/StatusTag/StatusTag';
import { StyledTooltip } from '@/components/shared/components/StyledTooltip';
import { StatusTagType } from '@/config/types';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface AgentsCountTagProps {
  agents: Pick<Agent, 'id' | 'name'>[];
  total: number;
  mixed: boolean;
}

export const AgentsCountTag = ({ agents, total, mixed }: AgentsCountTagProps) => {
  const { palette } = useCustomTheme();

  return (
    <FlexRow justifyContent="flex-start" gridGap={8}>
      <StatusTag
        type={mixed ? StatusTagType.WARNING : StatusTagType.SUCCESS}
        labelTextId={`${agents.length} / ${total}`}
      />
      {mixed && (
        <StyledTooltip title={agents.map((agent) => agent.name).join(', ')}>
          <span>
            <Icon size={18} color={palette.text.secondary}>
              info
            </Icon>
          </span>
        </StyledTooltip>
      )}
    </FlexRow>
  );
};
